import { renderMotherNatureCard } from './mother-nature-card';
import { renderCosmicWeatherCard } from './cosmic-weather-card';

export interface ThreatRowOptions {
  /** When true, only the cosmic weather card is shown (e.g. when Mother Nature is in the fold). */
  excludeMother?: boolean;
}

/**
 * Renders the threat duo row (Mother Nature + Cosmic weather) into the given container.
 */
export function renderThreatRow(
  container: HTMLElement,
  options?: ThreatRowOptions
): void {
  const wrap = document.createElement('div');
  wrap.className = ' threat-duo';

  if (!options?.excludeMother) {
    renderMotherNatureCard(wrap);
  }
  renderCosmicWeatherCard(wrap);

  container.appendChild(wrap);
}
